import { render, staticRenderFns } from "./UserActivityComponent.vue?vue&type=template&id=a4cf7476&scoped=true"
import script from "./UserActivityComponent.vue?vue&type=script&lang=js"
export * from "./UserActivityComponent.vue?vue&type=script&lang=js"
import style0 from "./UserActivityComponent.vue?vue&type=style&index=0&id=a4cf7476&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cf7476",
  null
  
)

export default component.exports